import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Loader from "components/Loader";
import { LOCALES } from "common/constants";
import { lazy } from "react";
import { useLocalizedRoutes } from "../v2/hooks/useLocalizedRoutes";
import LandingPage from "./../v2/pages/landing-page.page";
const FaqPage = lazy(() =>
  import("../v2/pages/faq-page.page").then((m) => ({ default: m.FaqPage }))
);
const FreelanceLifePage = lazy(() =>
  import("./../v2/pages/freelance-life.page").then((m) => ({ default: m.FreelanceLifePage }))
);
const SelfEmploymentPage = lazy(() =>
  import("./../v2/pages/self-employment.page").then((m) => ({ default: m.SelfEmploymentPage }))
);
const WorkConditionPage = lazy(() =>
  import("../v2/pages/work-condition.page.tsx").then((m) => ({ default: m.WorkConditionPage }))
);
const BusinessOrInvoicePage = lazy(() =>
  import("./../v2/pages/business-or-invoice.page").then((m) => ({ default: m.BusinessOrInvoicePage }))
);
const NewsPage = lazy(() => import("./../v2/pages/news-page.page"));
const NewsDetailPage = lazy(() => import("../v2/pages/news-detail.page"));
const BookKeepingPage = lazy(() => import("./../v2/pages/book-keeping-page.page"));
const FreelancingGuide = lazy(() => import("./../v2/pages/freelancing-guide-page.page"));
const ContactUsPage = lazy(() =>
  import("../v2/pages/contact-us.page").then((m) => ({ default: m.ContactUsPage }))
);
const Business = lazy(() =>
  import("../v2/pages/landing-page-bussiness.page").then((m) => ({ default: m.Business }))
);
const AmbassadorPage = lazy(() =>
  import("../v2/pages/ambassador-page.page").then((m) => ({ default: m.AmbassadorPage }))
);
const SelfEmployedInvoicingPage = lazy(() => import("../v2/pages/self-employed-invoicing.page.tsx"));
const AboutUsPage = lazy(() => import("../v2/pages/about-us.page"));
const HowItWorksPage = lazy(() => import("../v2/pages/how-it-works.page"));
const FeaturesPage = lazy(() => import("../v2/pages/features.page"));
const PrivateInsurancePageMain = lazy(() => import("../v2/pages/private-insurance-page"));
const InsurancePageMain = lazy(() => import("../v2/pages/insurance-page"));
const PensionPagePage = lazy(() => import("../v2/pages/pension-page"));
const HealthInsurancePage = lazy(() => import("../v2/pages/healthInsurance-page"));
const FreelanceIncomePotentialPage = lazy(() => import("../v2/pages/freelance-income-potential.page"));
const PrivacyPolicyPage = lazy(() => import("../v2/pages/privacy-policy.page"));
import { LoyaltyProgramPage } from "../v2/pages/loyalty-program.page";
// import RegistrationFormPage from "../v2/pages/registration-form.page";
const Faq = lazy(() => import("../views/dashboard/Faq"));
// const DashboardView = lazy(() => import("../views/dashboard"));
// const HomePage = lazy(() => import("../views/index"));
const AboutUs = lazy(() => import("components/layout/AboutUs"));
const SidebarInsurances = lazy(() => import("components/layout/outer-header/SidebarInsurances"));
const SidebarWorkingConditions = lazy(() =>
  import("components/layout/outer-header/SidebarWorkingConditions").then((m) => ({ default: m.SidebarWorkingConditions }))
);
const BussinesInfo = lazy(() => import("components/layout/outer-header/BussinesInfo"));
// const CompareDiffForms = lazy(() => import("components/layout/outer-header/CompareDiffForms"));
const InvoiceWithoutCompany2025 = lazy(() => import("components/layout/outer-header/InvoiceWithoutCompany2025"));
const CompanyReview = lazy(() => import("views/dashboard/seo-files/company-review/CompanyReview"));
// const InvoicingSelfEmployed = lazy(() =>
//   import("views/dashboard/seo-files/InvoicingSelfEmployed").then((m) => ({ default: m.InvoicingSelfEmployed }))
// );
// const FreelanceFreelancing = lazy(() =>
//   import("views/dashboard/seo-files/FreelanceFreelancing").then((m) => ({ default: m.FreelanceFreelancing }))
// );
const ApprovalNotifyPage = lazy(() => import("components/ApprovalNotifyPage"));
const Unsubscribed = lazy(() => import("components/Unsubscribed"));
const AuthorizedForReminder = lazy(() => import("components/AuthorizedForReminder"));
// const CookiesPage = lazy(() => import("components/layout/outer-header/cookiesPage"));
// const Ambassador = lazy(() => import("components/layout/Ambassador"));
// const SelfEmployment = lazy(() => import("components/layout/outer-header/SelfEmployment"));
// const InfoInspiration = lazy(() => import("components/layout/outer-header/InfoInspiration"));
const Negotiation = lazy(() => import("components/layout/outer-header/Negotiation"));
const GiggerVsInvozio = lazy(() => import("views/dashboard/seo-files/comparison/GiggerVsInvozio"));
const FrilansVsInvozio = lazy(() => import("views/dashboard/seo-files/comparison/FrilansVsInvozio"));
const CoolCompanyVsInvozio = lazy(() => import("views/dashboard/seo-files/comparison/CoolCompanyVsInvozio"));
const Error = lazy(() => import("views/Error"));
const DashboardView = lazy(() => import("views/dashboard"));
// const PensionInsurance = lazy(() => import("components/layout/outer-header/PensionInsurance"));
// const ManinHealthInsurance = lazy(() => import("components/layout/outer-header"));
// const HealthInsurance = lazy(() => import("components/layout/outer-header/HealthInsurance"));
const InvoiceAsConsultant = lazy(() =>
  import("components/layout/outer-header/InvoiceAsConsultant").then((m) => ({ default: m.InvoiceAsConsultant }))
);
import {DashboardPage} from "../v2/pages/dashboard.page";
import  {ProtectedRoute}  from './ProtectedRoute' 
import { LoyaltyProgramPage } from "../v2/pages/loyalty-program.page";
import CreateInvoicePage from "../v2/pages/create-invoice.page";
import ProfileSettingsPage from "../v2/pages/profile-settings.page";
import ManageInvoicePage from "../v2/pages/dashboard/manage-invoice.page";
import DraftInvoicePage from "../v2/pages/dashboard/draft-invoice.page"
import MyClientsPage from "../v2/pages/dashboard/my-client.page"
import MyFreelancersPage from "../v2/pages/dashboard/my-freelancer.page"
import HolidayPayReportPage from "../v2/pages/dashboard/holiday-pay-report.page"
import PensionReportPage from "../v2/pages/dashboard/pension-report.page"
import SalaryNoticePage from "../v2/pages/dashboard/salary-notice.page"
import MyFreelancersPage from "../v2/pages/dashboard/my-freelancer.page"
import MyContractsPage from "../v2/pages/dashboard/my-contracts.page"
import EmployerCertificatePage from "../v2/pages/dashboard/employer-certificate.page"
import MyFreelancersCertificatesPage from "../v2/pages/dashboard/my-freelancer-certificate.page"
import DeductionsPage from "../v2/pages/timesheet/deduction.page"
import StatementsPage from '../v2/pages/timesheet/statements.page';
import { InvoiceSalaryCalculatorPage } from "../v2/pages/salary-calculator.page";
import { HealthInsuranceDashboardPage } from "../v2/pages/health-insurance-dashboard.page";
import FaqDashboardPage from "../v2/pages/dashboard/faq-dashboardpage";
import TimeSheetsPage from "../v2/pages/timesheet/timeSheetsPage/timeSheetsPage";
import { PreInsurancePage } from "../v2/pages/pre-insurance.page";
import EmploymentContractPage from "../v2/pages/employment-contract.page";
import PartnerPage from "../v2/pages/dashboard/partner-page";

export const Router = ({ mobileScreen, dashboardFooter, language }) => {
  const { routes } = useLocalizedRoutes();
  return (
    <Routes>
      {/* Mobile Screen Pages Start */}
      <Route
        exact
        path="/mobile_faq"
        element={
          <Suspense
            fallback={
              <div>
                <Loader />
              </div>
            }
          >
            <Faq mobileScreen={mobileScreen} />
          </Suspense>
        }
      />
      <Route
        exact
        path="/mobile_about_us"
        element={
          <Suspense fallback={<Loader />}>
            <AboutUs mobileScreen={mobileScreen} />
          </Suspense>
        }
      />
      <Route
        exact
        path="/mobile_Insurance_admin"
        element={
          <Suspense fallback={<Loader />}>
            <SidebarInsurances mobileScreen={mobileScreen} />
          </Suspense>
        }
      />
      <Route
        exact
        path="/mobile_goodworking_conditions"
        element={
          <Suspense fallback={<Loader />}>
            <SidebarWorkingConditions mobileScreen={mobileScreen} />
          </Suspense>
        }
      />
      <Route
        exact
        path="/mobile_business_solution"
        element={
          <Suspense fallback={<Loader />}>
            <Business dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      {/* Mobile Screen Pages End */}

      <Route
        exact
        path="/"
        element={<LandingPage />}
      />

      <Route
        exact
        path={routes.function}
        element={
          <Suspense fallback={<Loader />}>
            <FeaturesPage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />

      <Route
        exact
        path="/faq"
        element={
          <Suspense
            fallback={
              <div>
                <Loader />
              </div>
            }
          >
            <FaqPage />
          </Suspense>
        }
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US ? "/how-works-invozio" : "/hur-fungerar-invozio"
        }
        element={
          <Suspense fallback={<Loader />}>
            <HowItWorksPage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />

      <Route
        exact
        path={language === LOCALES.EN_US ? "/about-invozio" : "/om-invozio"}
        element={
          <Suspense fallback={<Loader />}>
            <AboutUsPage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      <Route
        exact
        path={language === LOCALES.EN_US ? "/contact-us" : "/kontakta-oss"}
        element={
          <Suspense fallback={<Loader />}>
            <ContactUsPage />
          </Suspense>
        }
      />


      <Route
        exact
        path={language === LOCALES.EN_US ? "/dashboard/*" : "/instrumentbrada/*"}
        element={
          <Suspense fallback={<Loader />}>
            <DashboardView dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />

      <Route
        exact
        path={
          language === LOCALES.EN_US ? "/health-insurance-main" : "/sjukforsakring-huvud"
        }
        element={
          <Suspense fallback={<Loader />}>
            <HealthInsurancePage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />

      <Route
        exact
        path={language === LOCALES.EN_US ? "/health-insurance" : "/sjukforsakring"}
        element={
          <Suspense fallback={<Loader />}>
            <HealthInsurancePage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />

      <Route
        exact
        path={routes.privateCareInsurance}
        element={
          <Suspense fallback={<Loader />}>
            <PrivateInsurancePageMain />
          </Suspense>
        }
      />

      <Route
        exact
        path={language === LOCALES.EN_US ? "/pension" : "/pension"}
        element={
          <Suspense fallback={<Loader />}>
            <PensionPagePage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />

      <Route
        exact
        path="/external-help-with-payroll-management"
        element={
          <Suspense fallback={<Loader />}>
            <BussinesInfo dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/freelance-consultant-salary-invoice-without-a-company"
            : "/frilans-konsult-lon-fakturera-utan-foretag"
        }
        element={
          <Suspense fallback={<Loader />}>
            <BusinessOrInvoicePage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/invoicing-without-company-2025"
            : "/fakturering-utan-foretag-2025"
        }
        element={
          <Suspense fallback={<Loader />}>
            <InvoiceWithoutCompany2025 dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      {/* <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/working-as-a-freelancer-and-invoicing-without-tax-registration"
            : "/att-jobba-som-frilansare-och-fakturera-utan-fskatt"
        }
        element={<WorkingAsFreelancer dashboardFooter={dashboardFooter} />}
      /> */}
      <Route
        exact
        path={routes.workingFreelancer}
        element={
          <Suspense fallback={<Loader />}>
            <FreelanceLifePage />
          </Suspense>
        }
      />
      {/* <Route
        exact
        path="/recension-av-faktura-utan-foretag-frilansfinans-coolcompany-gigger"
        element={
          <Suspense fallback={<Loader />}>
            <CompanyReview />
          </Suspense>
        }
      /> */}
      <Route
        exact
        path="/gigger-vs-Invozio"
        element={
          <Suspense fallback={<Loader />}>
            <GiggerVsInvozio />
          </Suspense>
        }
      />
      <Route
        exact
        path="/frilans-finans-vs-Invozio"
        element={
          <Suspense fallback={<Loader />}>
            <FrilansVsInvozio />
          </Suspense>
        }
      />
      <Route
        exact
        path="/cool-company-vs-Invozio"
        element={
          <Suspense fallback={<Loader />}>
            <CoolCompanyVsInvozio />
          </Suspense>
        }
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/how-much-should-I-invoice-as-a-freelancer"
            : "/hur-mycket-ska-jag-fakturera-som-frilansare"
        }
        element={
          <Suspense fallback={<Loader />}>
            <FreelanceIncomePotentialPage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/from-invoice-to-negotiation"
            : "/fran-faktura-till-forhandling"
        }
        element={
          <Suspense fallback={<Loader />}>
            <Negotiation dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      <Route
        exact
        path={language === LOCALES.EN_US ? "/business" : "/foretag"}
        // element={<Business dashboardFooter={dashboardFooter} />}
        element={
          <Suspense fallback={<Loader />}>
            <Business />
          </Suspense>
        }
      />
      <Route
        exact
        path={routes.selfEmployment}
        element={
          <Suspense fallback={<Loader />}>
            <SelfEmploymentPage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      <Route
        exact
        path={routes.startBusiness}
        element={
          <Suspense fallback={<Loader />}>
            <WorkConditionPage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      <Route
        exact
        path={routes.invoiceWithoutCompany}
        element={
          <Suspense fallback={<Loader />}>
            <BusinessOrInvoicePage />
          </Suspense>
        }
      />
      <Route
        exact
        path={routes.ambassador}
        element={
          <Suspense fallback={<Loader />}>
            <AmbassadorPage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      <Route
        exact
        path="/cookies"
        element={
          <Suspense fallback={<Loader />}>
            <PrivacyPolicyPage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      <Route
        exact
        path="/error"
        element={
          <Suspense fallback={<Loader />}>
            <Error />
          </Suspense>
        }
      />

      <Route
        exact
        path={language === LOCALES.EN_US ? "/unsubscribed" : "/avprenumererad"}
        element={
          <Suspense fallback={<Loader />}>
            <Unsubscribed />
          </Suspense>
        }
      />
      <Route
        exact
        path={language === "en" ? "/authorize-reminder" : "/auktorisera-påminnelse"}
        element={
          <Suspense fallback={<Loader />}>
            <AuthorizedForReminder />
          </Suspense>
        }
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US ? "/approval-notify" : "/godkannande-meddelande"
        }
        element={
          <Suspense fallback={<Loader />}>
            <ApprovalNotifyPage />
          </Suspense>
        }
      />
      {/* <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/freelance-freelancing"
            : "/frilans-frilansarbete"
        }
        element={<FreelanceFreelancing dashboardFooter={dashboardFooter} />}
      /> */}
      <Route
        exact
        path={routes.freelancingGuide}
        element={
          <Suspense fallback={<Loader />}>
            <FreelancingGuide />
          </Suspense>
        }
      />
      {/* <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/freelance-income-potential"
            : "/frilans-inkomstpotential"
        }
        element={<FreelanceIncomePotentialPage dashboardFooter={dashboardFooter} />}
      /> */}

      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/invoice-as-consultant-salary"
            : "/fakturera-som-konsult-lon"
        }
        element={
          <Suspense fallback={<Loader />}>
            <InvoiceAsConsultant dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      <Route
        exact
        path={routes.newsDetail}

        element={
          <Suspense fallback={<Loader />}>
            <NewsDetailPage />
          </Suspense>
        }
      />
      <Route
        exact
        path={routes.news}
        element={
          <Suspense fallback={<Loader />}>
            <NewsPage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      <Route
        exact
        path={routes.bookKeeping}
        element={
          <Suspense fallback={<Loader />}>
            <BookKeepingPage />
          </Suspense>
        }
      />
      <Route
        exact
        path={routes.loyaltyProgram}
        element={
          <ProtectedRoute>
            <LoyaltyProgramPage />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path={routes.invoicingIndividual}
        element={
          <Suspense fallback={<Loader />}>
            <SelfEmployedInvoicingPage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />

      <Route
        exact
        // path={language === LOCALES.EN_US ? "/insurance" : "/forsakring"}
        path={routes.insurance}
        element={
          <Suspense fallback={<Loader />}>
            <InsurancePageMain dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
            <Route
        exact
        path={routes.loyaltyProgram}
        element={
          <ProtectedRoute>
            <LoyaltyProgramPage />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path={routes.invoicingIndividual}
        element={<SelfEmployedInvoicingPage dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={routes.dashboardV2}
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />

      <Route
        exact
        // path={language === LOCALES.EN_US ? "/insurance" : "/forsakring"}
        path={routes.insurance}
        element={<InsurancePageMain dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        // path={language === LOCALES.EN_US ? "/insurance" : "/forsakring"}
        path={routes.insurance}
        element={<InsurancePageMain dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={routes.profileSettings}
        element={
          <ProtectedRoute>
            <ProfileSettingsPage />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path={routes.manageinvoice}
        element={
          <ProtectedRoute>
            <ManageInvoicePage />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path={routes.draftInvoice}
        element={
          <ProtectedRoute>
            <DraftInvoicePage />
          </ProtectedRoute>
        }
      />

      <Route
        exact
        path={routes.myClients}
        element={
          <ProtectedRoute>
            <MyClientsPage />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path={routes.myFreelancers}
        element={
          <ProtectedRoute>
            <MyFreelancersPage />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path={routes.myContracts}
        element={
          <ProtectedRoute>
            <MyContractsPage />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path={routes.employerCertificate}
        element={
          <ProtectedRoute>
            <EmployerCertificatePage />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path={routes.myFreelancersCertificates}
        element={
          <ProtectedRoute>
            <MyFreelancersCertificatesPage />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path={routes.salaryNotice}
        element={
          <ProtectedRoute>
            <SalaryNoticePage />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path={routes.HolidayPayReport}
        element={
          <ProtectedRoute>
            <HolidayPayReportPage />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path={routes.pensionReport}
        element={
          <ProtectedRoute>
            <PensionReportPage />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path={routes.salaryCalculatorPage}
        element={
          <ProtectedRoute>
            <InvoiceSalaryCalculatorPage />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path={routes.healthInsurancePage}
        element={
          <ProtectedRoute>
            <HealthInsuranceDashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path={routes.createInvoice}
        element={
          <ProtectedRoute>
            <CreateInvoicePage />
          </ProtectedRoute>
        }
      />

            <Route
        exact
        path={routes.deductionInvoice}
        element={
          <ProtectedRoute>
            <DeductionsPage />
          </ProtectedRoute>
        }
      />
       <Route
        exact
        path={routes.timeSheetsPage}
        element={
          <ProtectedRoute>
           <TimeSheetsPage />
          </ProtectedRoute>
        }
      />
                  <Route
        exact
        path={routes.statementsPage}
        element={
          <ProtectedRoute>
            <StatementsPage />
          </ProtectedRoute>
        }
      />

      <Route
        exact
        path={routes.faqDashboard}
        element={
          <ProtectedRoute>
            <FaqDashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path={routes.preInsurance}
        element={
          <ProtectedRoute>
            <PreInsurancePage />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path={routes.employmentContract}
        element={
          <ProtectedRoute>
            <EmploymentContractPage />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path={routes.partnerPage}
        element={
          <ProtectedRoute>
            <PartnerPage />
          </ProtectedRoute>
        }
      />
    </Routes>



  );
};
